import type { ZodSchema } from 'zod';

import { captureSchemaValidationError } from '../sentry/sentry';

export const validateSchema =
  <T>(Schema: ZodSchema<T>) =>
  (result: unknown) => {
    const validationResult = Schema.safeParse(result);

    if (!validationResult.success) {
      captureSchemaValidationError(validationResult.error, {
        contexts: {
          response: {
            apiResponse: result,
          },
          error: {
            schemaError: validationResult.error.issues,
          },
        },
      });
      throw validationResult.error;
    }

    return validationResult.data;
  };
